import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import API from "../api.js";
import { setAlert } from "action/index.js";
import { store } from "store/index";
import SimpleReactValidator from "simple-react-validator";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import Frame1 from "../assets/images/public-pages/Frame1.svg"
import Frame2 from "../assets/images/public-pages/Frame2.svg"
import Frame3 from "../assets/images/public-pages/Frame3.svg"
import Frame4 from "../assets/images/public-pages/Frame4.svg"
import Frame5 from "../assets/images/public-pages/Frame5.svg";
import Frame6 from "../assets/images/public-pages/Frame6.svg";
import Frame7 from "../assets/images/public-pages/Frame7.svg";
import Frame8 from "../assets/images/public-pages/Frame8.svg";
import Frame9 from "../assets/images/public-pages/Frame9.svg";
import Frame10 from "../assets/images/public-pages/Frame10.svg";
import Frame11 from "../assets/images/public-pages/Frame11.svg";
import Frame12 from "../assets/images/public-pages/Frame12.svg";
import Frame13 from "../assets/images/public-pages/Frame13.svg";
import Frame14 from "../assets/images/public-pages/Frame14.svg";
import Frame15 from "../assets/images/public-pages/Frame15.svg";
import Frame16 from "../assets/images/public-pages/Frame16.svg";
import Frame17 from "../assets/images/public-pages/Frame17.svg";
import Frame18 from "../assets/images/public-pages/Frame18.svg";
import Frame19 from "../assets/images/public-pages/Frame19.svg";
import '../../public/css/new-app.css'
import ReusableHomePageSlider from "./ReusableHomePageSlider";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import TestimonialSection from "components/PublicPagesReusable/TestimonialSection";
import FeatureSection from "components/PublicPagesReusable/FeatureSection";
import AiPower from "components/PublicPagesReusable/AiPowerSection";
import SplitSection from "components/PublicPagesReusable/SplitSection";
import QRCode from "react-qr-code";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import Complement from "../assets/images/public-pages/complement.svg";
import Essential from "../assets/images/public-pages/essential.svg";
import Professional from "../assets/images/public-pages/professional.svg";
import Commuters from "../assets/images/public-pages/commuters.svg";
import Seamless from "../assets/images/public-pages/seamless-integrate.svg";
import Smart from "../assets/images/public-pages/smart-progress.svg";
import Regular from "../assets/images/public-pages/Regular-update.svg";
import Expert from "../assets/images/public-pages/Expert-designed.svg";

const PTEAppNew = () => {
  const navigate = useNavigate();
  const validator = useRef(new SimpleReactValidator());
  const sliderRef = useRef(null);

  const [state, setState] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    error: [],
    submit: false,
    flag: false,
    lockSubmit: false,
    homePage: false,
    list: [],
    sliderStyles: { marginLeft: "0px", width: "100%" },
  });

  const adjustSliderWidth = useCallback(() => {
    const container = document.querySelector(".container");
    const outerDiv = document.querySelector(".outer-wrapper");
    const slickList = document.querySelector(".slick-list");
    if (container && outerDiv && slickList) {
      const leftWidth = container.getBoundingClientRect().left;
      const rightWidth =
        outerDiv.getBoundingClientRect().right - window.innerWidth;
      setState((prev) => ({
        ...prev,
        sliderStyles: {
          marginLeft: `${leftWidth}px`,
          width: `calc(100vw - ${leftWidth}px + ${Math.abs(rightWidth)}px)`,
        },
      }));
    }
  }, []);

  useEffect(() => {
    adjustSliderWidth();
    window.addEventListener("resize", adjustSliderWidth);

    // Analytics and pixel initialization
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();

    return () => {
      window.removeEventListener("resize", adjustSliderWidth);
    };
  }, [adjustSliderWidth]);

  const handleChange = useCallback((event) => {
    const { name, value } = event.target;
    setState((prev) => ({ ...prev, [name]: value }));
  }, []);

  const submitForm = useCallback(() => {
    if (validator.current.allValid() && !state.lockSubmit) {
      setState((prev) => ({ ...prev, lockSubmit: true }));

      const json = {
        name: state.name,
        email: state.email,
        phone: state.phone,
        message: state.message,
      };

      API({
        method: "POST",
        url: "post/contact",
        data: json,
      })
        .then((data) => {
          setState((prev) => ({
            ...prev,
            submit: true,
            lockSubmit: false,
            name: "",
            email: "",
            phone: "",
            message: "",
            flag: true,
          }));

          store.dispatch(
            setAlert({
              flag: true,
              type: 1,
              message: data.data.response.message,
            })
          );
        })
        .catch(() => {
          setState((prev) => ({ ...prev, lockSubmit: false }));
        });
    } else {
      validator.current.showMessages();
      // force re-render to show validation messages
      setState((prev) => ({ ...prev }));
    }
  }, [state.lockSubmit, state.name, state.email, state.phone, state.message]);

  // Redirect after successful submission
  useEffect(() => {
    if (state.flag) {
      navigate("/thank-you", { replace: true });
    }
  }, [state.flag, navigate]);

  const pteSlider = {
    dots: true,
    arrows: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 5 } },
      { breakpoint: 768, settings: { slidesToShow: 4 } },
      { breakpoint: 576, settings: { slidesToShow: 2 } },
    ],
  };

  const CardsSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    adaptiveHeight: true,
    autoplaySpeed: 5000,
  };


  const academySections = [
    {
      title: (
        <>
          PTE Complete Question Bank
        </>
      ),
      highlight: "29,000+ Practice Questions Covering All Exam Modules",
      features: [
        "All 22 PTE question types with detailed explanations",
        "Algorithm-based scoring that mirrors the real exam",
        "Updated templates designed to trigger maximum points",
      ],
      iconBg: "#F4EBFF",
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#48A75C" />

          <path
            d="M42.3318 22.6667C44.2216 25.2936 45.3346 28.5168 45.3346 32C45.3346 35.4831 44.2216 38.7063 42.3318 41.3333M36.995 26.6667C38.0495 28.1784 38.668 30.017 38.668 32C38.668 33.983 38.0495 35.8215 36.995 37.3333M28.8471 23.1542L24.6261 27.3751C24.3955 27.6057 24.2802 27.721 24.1457 27.8035C24.0264 27.8766 23.8963 27.9305 23.7603 27.9631C23.6068 28 23.4438 28 23.1176 28H20.8013C20.0546 28 19.6812 28 19.396 28.1453C19.1451 28.2731 18.9411 28.4771 18.8133 28.728C18.668 29.0132 18.668 29.3866 18.668 30.1333V33.8667C18.668 34.6134 18.668 34.9868 18.8133 35.272C18.9411 35.5229 19.1451 35.7268 19.396 35.8547C19.6812 36 20.0546 36 20.8013 36H23.1176C23.4438 36 23.6068 36 23.7603 36.0368C23.8963 36.0695 24.0264 36.1234 24.1457 36.1965C24.2802 36.2789 24.3955 36.3942 24.6261 36.6248L28.8471 40.8457C29.4182 41.4169 29.7038 41.7025 29.949 41.7218C30.1617 41.7385 30.3696 41.6524 30.5082 41.4901C30.668 41.3031 30.668 40.8992 30.668 40.0915V23.9085C30.668 23.1007 30.668 22.6968 30.5082 22.5098C30.3696 22.3476 30.1617 22.2614 29.949 22.2782C29.7038 22.2975 29.4182 22.5831 28.8471 23.1542Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      imageSrc: '/images/web-new-images/emojis/Updated/Core-first.png'
    },
    {
      title: (
        <>
          Realistic Practice Dialogues and Audio
        </>
      ),
      highlight: "Comprehensive Listening Practice",
      features: [
        "Authentic accent training with varied speaking speeds",
        "Real exam-style audio content",
        "Integrated scoring across all sections",
      ],
      iconBg: "#0286FF1F",
      icon: (
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="64" height="64" rx="32" fill="#48A75C"/>
      <path d="M42.6654 32V33.3333C42.6654 39.2244 37.8897 44 31.9987 44C26.1077 44 21.332 39.2244 21.332 33.3333V32M31.9987 38.6667C29.0532 38.6667 26.6654 36.2789 26.6654 33.3333V25.3333C26.6654 22.3878 29.0532 20 31.9987 20C34.9442 20 37.332 22.3878 37.332 25.3333V33.3333C37.332 36.2789 34.9442 38.6667 31.9987 38.6667Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      ),
      imageSrc: '/images/web-new-images/emojis/Updated/Core-second.png'
    },
    {
      title: (
        <>
          Real-Time Exam Simulation
        </>
      ),
      highlight: "Mock Tests That Mirror the Actual Experience",
      features: [
        "Full-length scored mock tests with precise feedback",
        "AI-powered assessment matching real exam algorithms",
        "Comprehensive performance analytics",
      ],
      iconBg: "#FFB02C1F",
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#48A75C" />

          <path
            d="M42.3318 22.6667C44.2216 25.2936 45.3346 28.5168 45.3346 32C45.3346 35.4831 44.2216 38.7063 42.3318 41.3333M36.995 26.6667C38.0495 28.1784 38.668 30.017 38.668 32C38.668 33.983 38.0495 35.8215 36.995 37.3333M28.8471 23.1542L24.6261 27.3751C24.3955 27.6057 24.2802 27.721 24.1457 27.8035C24.0264 27.8766 23.8963 27.9305 23.7603 27.9631C23.6068 28 23.4438 28 23.1176 28H20.8013C20.0546 28 19.6812 28 19.396 28.1453C19.1451 28.2731 18.9411 28.4771 18.8133 28.728C18.668 29.0132 18.668 29.3866 18.668 30.1333V33.8667C18.668 34.6134 18.668 34.9868 18.8133 35.272C18.9411 35.5229 19.1451 35.7268 19.396 35.8547C19.6812 36 20.0546 36 20.8013 36H23.1176C23.4438 36 23.6068 36 23.7603 36.0368C23.8963 36.0695 24.0264 36.1234 24.1457 36.1965C24.2802 36.2789 24.3955 36.3942 24.6261 36.6248L28.8471 40.8457C29.4182 41.4169 29.7038 41.7025 29.949 41.7218C30.1617 41.7385 30.3696 41.6524 30.5082 41.4901C30.668 41.3031 30.668 40.8992 30.668 40.0915V23.9085C30.668 23.1007 30.668 22.6968 30.5082 22.5098C30.3696 22.3476 30.1617 22.2614 29.949 22.2782C29.7038 22.2975 29.4182 22.5831 28.8471 23.1542Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      imageSrc: '/images/web-new-images/emojis/Updated/Core-third.png'
    },
    {
      title: (
        <>
          Proven Success Strategies
        </>
      ),
      highlight: "Expert Tips for First-Attempt Success",
      features: [
        "Updated templates for all question types",
        "Section-specific strategies for maximum scores",
        "Real-time feedback on speaking and writing tasks",
      ],
      iconBg: "#94C23C1F",
      icon: (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="32" fill="#48A75C"/>
        <path d="M42.6654 32V33.3333C42.6654 39.2244 37.8897 44 31.9987 44C26.1077 44 21.332 39.2244 21.332 33.3333V32M31.9987 38.6667C29.0532 38.6667 26.6654 36.2789 26.6654 33.3333V25.3333C26.6654 22.3878 29.0532 20 31.9987 20C34.9442 20 37.332 22.3878 37.332 25.3333V33.3333C37.332 36.2789 34.9442 38.6667 31.9987 38.6667Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      ),
      imageSrc: '/images/web-new-images/emojis/Updated/Core-four.png'
    },
    {
      title: (
        <>
          Seamless Mobile Experience
        </>
      ),
      highlight: "Study Anywhere, Anytime with Zero Compromise",
      features: [
        "Offline access to all vocabulary and practice materials",
        "Progress tracking across all devices",
        "Never miss a learning opportunity again",
      ],
      iconBg: "#FFB02C1F",
      icon: (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="64" height="64" rx="32" fill="#48A75C" />

          <path
            d="M42.3318 22.6667C44.2216 25.2936 45.3346 28.5168 45.3346 32C45.3346 35.4831 44.2216 38.7063 42.3318 41.3333M36.995 26.6667C38.0495 28.1784 38.668 30.017 38.668 32C38.668 33.983 38.0495 35.8215 36.995 37.3333M28.8471 23.1542L24.6261 27.3751C24.3955 27.6057 24.2802 27.721 24.1457 27.8035C24.0264 27.8766 23.8963 27.9305 23.7603 27.9631C23.6068 28 23.4438 28 23.1176 28H20.8013C20.0546 28 19.6812 28 19.396 28.1453C19.1451 28.2731 18.9411 28.4771 18.8133 28.728C18.668 29.0132 18.668 29.3866 18.668 30.1333V33.8667C18.668 34.6134 18.668 34.9868 18.8133 35.272C18.9411 35.5229 19.1451 35.7268 19.396 35.8547C19.6812 36 20.0546 36 20.8013 36H23.1176C23.4438 36 23.6068 36 23.7603 36.0368C23.8963 36.0695 24.0264 36.1234 24.1457 36.1965C24.2802 36.2789 24.3955 36.3942 24.6261 36.6248L28.8471 40.8457C29.4182 41.4169 29.7038 41.7025 29.949 41.7218C30.1617 41.7385 30.3696 41.6524 30.5082 41.4901C30.668 41.3031 30.668 40.8992 30.668 40.0915V23.9085C30.668 23.1007 30.668 22.6968 30.5082 22.5098C30.3696 22.3476 30.1617 22.2614 29.949 22.2782C29.7038 22.2975 29.4182 22.5831 28.8471 23.1542Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      imageSrc: '/images/web-new-images/emojis/Updated/Core-five.png'
    },
  ];

  const lifestyleCards = [
    {
      title: "Perfect For Commuters",
      text: "Transform your daily travel time into productive exam preparation. Practice PTE speaking tasks during train rides, or review dialogues and templates while waiting.",
      color: 'rgba(255, 255, 255, 0)',
      img: Commuters,
      hoverColor: "#FFCC00",
    },
    {
      title: "Ideal For Working Professionals",
      text: "Squeeze in focused practice sessions during lunch breaks, before meetings, or whenever you have 10-15 spare minutes. PTE preparation based on your priorities.",
      color: 'rgba(255, 255, 255, 0)',
      img: Professional,
      hoverColor: "#FF2D55",
    },
    {
      title: "Essential For Students",
      text: "Balance your exam preparation with university commitments. Study efficiently PTE without compromising your academic schedule.",
      color: 'rgba(255, 255, 255, 0)',
      img: Essential,
      hoverColor: "#34C759",
    },
    {
      title: "Complement To Classroom Learning",
      text: "Never fall behind even if you miss in-person classes. Access the same quality materials and exercises for both exams from anywhere.",
      color: 'rgba(255, 255, 255, 0)',
      img: Complement,
      hoverColor: "#007AFF",
    },
  ];
    const images = [{
      src: Frame1,
      alt: "score-1",
    },
    {
      src: Frame2,
      alt: "score-2",
    },
    {
      src: Frame3,
      alt: "score-3",
    },
    {
      src: Frame4,
      alt: "score-4",
    },
    {
      src: Frame5,
      alt: "score-5",
    },
    {
      src: Frame6,
      alt: "score-6",
    },{
      src: Frame7,
      alt: "score-7",
    },
    {
      src: Frame8,
      alt: "score-8",
    },
    {
      src: Frame9,
      alt: "score-9",
    },
    {
      src: Frame10,
      alt: "score-10",
    },
    {
      src: Frame11,
      alt: "score-11",
    },
    {
      src: Frame12,
      alt: "score-12",
    },
    {
      src: Frame13,
      alt: "score-13",
    },
    {
      src: Frame14,
      alt: "score-14",
    },{
      src: Frame15,
      alt: "score-15",
    },
    {
      src: Frame16,
      alt: "score-16",
    },
    {
      src: Frame17,
      alt: "score-17",
    },
    {
      src: Frame18,
      alt: "score-18",
    },
    {
      src: Frame19,
      alt: "score-19",
    }
];

const skillAreaTitle = () => {
    return (
   <h3 className="top-section-text FS56FW500 mb-4 white">
    Designed For Your <span className="text-success">Busy <br/> Lifestyle</span>
    </h3>
    )
  }

    const sliderList = {
    title: "What Our <span>Students Say</span>",
    subtitle: "Real success stories from our learners",

    settings: {
      slidesPerView: 3,
      spaceBetween: 20,
      breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
    },
    items: [
      {
        id: 1,
        name: "Gagan Brar",
        location: "-",
        description:
          "I had a great experience at language academy and scored 8 bands in each. Roopali was an amazing tutor. She kept in touch with me right up until I got my results and supported me the whole way. Her lessons really helped me improve, especially in Writing and Speaking. I highly recommend it!",
        image: "/images/web-new-images/new-content-slider/gagan-brar.svg",
      },
      {
        id: 2,
        name: "Manisha Rathore",
        location: "Jodhpur City, Rajasthan, India",
        description:
          "I achieved 90 overall by the help of tricks and tips suggested by tutors on language academy online portal and sessions. I highly recommend the course. Special thanks to Varun sir and Shiba mam.",
        image: "/images/web-new-images/new-content-slider/Manisha-rathore.svg",
      },
      {
        id: 3,
        name: "CeMas Poojas",
        location: "Cabadbaran, Agusan del Norte",
        description:
          "I would like to express my sincere gratitude to LA Academy for their outstanding support and guidance during my PTE preparation. I just received my results today, and I am excited to share that I achieved an overall score of 80! A special thank you to Ma'am Sana and the entire team for your dedication and encouragement. Your efforts truly made a difference in my success. I highly recommend LA Academy to anyone looking to excel in their language proficiency tests!",
        image: "/images/web-new-images/new-content-slider/ceemas-poojas.svg",
      },
      {
        id: 4,
        name: "Riddhi Patel",
        location: "Rajkot, Gujarat",
        description:
          "I just got 4 online one on one classes with vishika. She is really good in understanding the dilemma of the students, and suggests the tips, tricks and ideas according to that. I got 81 overall score with 7 each in two modules and 8 each in other modules. I am really happy to study with a language academy, and especially with vishika. Thank you so much for making my journey easier…….",
        image: "/images/web-new-images/new-content-slider/riddhi-patel.svg",
      },
      {
        id: 5,
        name: "Shoaib Awan",
        location: "Abbottabad",
        description:
          "Sir Varun’s tips and tricks really helped me gain a score that was way better than my desired score in the very first attempt. Thank you so much Sir Varun and team language academy. You guys are doing a great job.",
        image: "/images/web-new-images/new-content-slider/shoaib-awan.svg",
      },
      {
        id: 6,
        name: "Nellam Kumari",
        location: "-",
        description:
          "The LA website is one of the best websites to practice and get real time feedback as well. The mock tests are realistic and practice questions are segregated by level of difficulty. I prepared mostly by watching Varun's videos on youtube and practicing on the website and got a 90 score. I also had a one on one session with Navneet Kaur from LA to get my mock tests and approach reviewed. She had been very helpful and responsive in addressing my queries. Thanks a lot tea",
        image: "/images/web-new-images/new-content-slider/neelam-kumari.svg",
      },{
        id: 7,
        name: "Liza Liza",
        location: "Brisbane, Queensland, Australia",
        description:
          "I’m incredibly grateful to LA Academy for helping me achieve my desired PTE score! The guidance, strategies, and constant support from the trainers made a huge difference in my preparation. The practice materials were up-to-date and very similar to the actual exam. What I appreciated most was the personal attention and honest feedback, which helped me improve my weak areas quickly. Thank you LA Academy for your dedication and for helping me reach my goal. Highly recommend to anyone serious about getting their target PTE score!",
        image: "/images/web-new-images/new-content-slider/liza.svg",
      },{
        id: 8,
        name: "Varinder Sandhu",
        location: "Kot-Ise-Khan, Punjab, India",
        description:
          "Hii I am a online student of language academy I took online PTE coaching from language academy and today I have achieve my desired score with the help of language academy secret strategies and tips special thanks to manan wadhwa mam she helped me alot  in my PTE classes",
        image: "/images/web-new-images/new-content-slider/varinder-sandhu.svg",
      },{
        id: 9,
        name: "Shreya Pokhrel",
        location: "Punjab, India",
        description:
          "I would highly recommend LA academy. I was able to secure 8 within 2 weeks of time. They are always willing to help you at any time. Vishika mam, she was super flexible and always replied to me whenever I messaged her. I just wanted to let you know, if you actually want to score your desired band, then LA Academy is your ultimate destination.",
        image: "/images/web-new-images/new-content-slider/shreya-pokhrel.svg",
      },
    ]
  };

  const featureData = {
    title: "More Than Apps, They’re Your",
    highlightText: "Success Companions",
    bottomText: "This isn't just practice, it's precision preparation.",
    ctaText: "Start Your Precision Preparation",
    onCtaClick: '/auth/register',
    cards: [
      {
        icon: Seamless,
        title: "Seamless Integration",
        borderColor:'#FFFFFF3D',
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        description:
          "Works perfectly alongside our online classes and in-person coaching. Your progress syncs across all platforms for PTE preparation.",
      },
      {
        icon: Smart,
        title: "Smart Progress Tracking",
        borderColor:'#FFFFFF3D',
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        description:
          "Monitor your improvement across all vocabulary categories, dialogue types, and PTE question formats. See exactly where you need to focus for each exam.",
      },
      {
        icon: Expert,
        title: "Expert-Designed Content",
        borderColor:'#FFFFFF3D',
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        description: "Every feature, dialogue, vocabulary list, and PTE template is crafted by certified professionals who understand both exams inside out.",
      },
      {
        icon: Regular,
        title: "Regular Updates",
        borderColor:'#FFFFFF3D',
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        description: "Content is continuously updated based on recent exam patterns and feedback from successful students for PTE",
      },
    ],
  };

  const spliteSectionData = {
    title: "The Bottom Line:",
    highlight: "Your Success is Mobile",
    quote: "Achieving high PTE scores isn't rocket science, but it does require smart, consistent preparation.",
    descriptions: [
      "We understand the life-changing value of those 5 points for Australian permanent residency and the global opportunities that come with strong PTE scores. That's why we've created the most comprehensive, convenient, and effective language exam preparation apps available.",
      "Your dreams deserve expert preparation, now available wherever you are.",
    ],
    features: [
      "Busy schedule? Practice on your commute",
      "Missed a class? Access the same materials instantly",
      "Need quick review? Everything's in your pocket",
      "Multiple exams to prepare for? Switch between PTE seamlessly",
      "Exam tomorrow? Last-minute packages have you covered",
    ],
    buttonText: "Download Now And Transform Your Commute Into Exam Success",
    onButtonClick: () => {
      window.open(import.meta.env.VITE_PTE_IOS_APP_URL, "_blank");
    },
    image: "/images/web-new-images/emojis/Updated/BottomLine.png",
    imagePosition: "left",
    bgColor: "#ffffff",
    textColor: "#000000",
  };
  return (
    <React.Fragment>
      <Helmet>
        <title>PTE App: AI-Powered PTE Practice App for Mock Tests</title>
        <meta
          name="description"
          content="Prepare smarter with our PTE App. Access AI-scored mock tests, practice questions, speaking tasks, and real exam simulation to improve your PTE score faster."
        />
        <meta name="twitter:title" content="PTE App: AI-Powered PTE Practice App for Mock Tests" />
        <meta property="og:title" content="PTE App: AI-Powered PTE Practice App for Mock Tests" />
      </Helmet>
      <Header />
      <main className="new-design">
        <div className="banner-section mt-0 noc-banner pt-0">
          <section
            className="naati-hero-section"
            style={{
              '--background-color':'linear-gradient(135deg,#9e7de7 -15%,#050b2d 10% 40%,#05f 98%)',
              "--text-color": "black",
              paddingTop: '80px'
            }}
          >
            <div className="container-fluid hero-new py-5">
              <div className="custom-container">
                <div className="row justify-content-center text-center">
                  {/* Top Tag */}
                  <div className="col-12 mb-3">
                    <span className="students-stat mb-4 text-white">
                      Best PTE Training Institute, NAATI CCL & IELTS Prep.
                    </span>
                  </div>

                  {/* Heading */}
                  <div className="row">
                    {/* Left Stats */}
                    <div className="col-lg-2 text-center text-lg-start mb-4 mb-lg-0 align-content-center">
                      <h3 className="target FS40FW600 mb-0">1M+</h3>
                      <p className="downloads-text text-white">Downloads</p>

                      <div className="avatars d-flex justify-content-center justify-content-lg-start">
                        <img
                          src="/images/web-new-images/new-content-slider/User-01.svg"
                          className="avatar rounded-circle"
                        />
                        <img
                          src="/images/web-new-images/new-content-slider/Pritam.svg"
                          className="avatar rounded-circle ms-n3"
                        />
                        <img
                          src="/images/web-new-images/new-content-slider/Karthik-B.svg"
                          className="avatar rounded-circle ms-n3"
                        />
                        <img
                          src="/images/web-new-images/new-content-slider/RamimRahman-demo.svg"
                          className="avatar rounded-circle ms-n3"
                        />
                         <img
                          src="/images/web-new-images/new-content-slider/SapnaPandey-demo.svg"
                          className="avatar rounded-circle ms-n3"
                        />
                      </div>
                    </div>
                    <div className="col-lg-8">
                      <h1 className="hero-title mb-3 text-white">
                        Master <span className="text-success">PTE</span> From
                        Anywhere <br />
                        Best PTE Exam Practice App
                      </h1>
                      <div className="tropiline FS24FW500 fw-700 text-center my-3 text-white">
                        <span>For PTE Academic, PTE Core and PTE UKVI</span>
                      </div>
                      <p className="FS20FW500 mb-4" style={{color:'#DEDEDE'}}>
                        The complete mobile solution that ensures your language proficiency goals are always within reach, wherever life takes you.
                      </p>
                      <div className="align-items-center d-flex gap-2 justify-content-center mt-5">
                        <ButtonComp
                          link={() => window.open('https://apps.apple.com/us/app/la-pte/id6443614190')}
                          btnText={"Download Our App Today"}
                          img="/images/web-new-images/new-dark-arrow.svg"
                        />
                        <button className="border-btn gap-2 primary-btn w-sm-100 w-auto" onClick={() => navigate("/auth/register")}>Free Mock Test <img src={`/images/web-new-images/new-green-arrow.png`} alt="Register Now" />
                      </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bottom Section */}
                <div className="row align-items-end position-relative">
                  {/* Phones */}
                  <div className="bottom-images d-flex gap-4 justify-content-center phones-wrapper position-relative text-center">
                    <img
                      src="/images/web-new-images/emojis/Updated/iPhone-Left.webp"
                      className="phone phone-left"
                      alt="Iphone Left"
                    />

                    <img
                      src="/images/web-new-images/emojis/Updated/iPhone-Center.webp"
                      className="phone phone-center"
                      alt="Iphone Center"
                    />

                    <img
                      src="/images/web-new-images/emojis/Updated/iPhone-Right.webp"
                      className="phone phone-right"
                      alt="Iphone Right"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Download Section */}
          <div className="mb-5">
            <section className="download-section custom-container" style={{'--background-color':'#fff','--text-color':'#000'}}>
              <div className="download-container py-5">
                <div className="row align-items-center">
                  {/* Left Content */}
                  <div className="col-lg-6 mb-4 mb-lg-0">
                    <h2 className="top-section-text FS40FW600 fw-600"> 
                      Download Our{" "}
                      <span className="text-success FS40FW600">
                        PTE App
                      </span><br/>
                      Today!
                    </h2>

                    <p className="subtitle FS17FW500">
                      Achieve your Australian permanent residency dreams and
                      global opportunities with our powerful mobile apps, designed
                      specifically for busy professionals, students, and
                      immigrants who need flexible, expert-level preparation for
                      PTE exams.
                    </p>

                    {/* <button className="primary-btn" type="button" onClick={()=>{console.log('Btn Click')}}>
                      Download Our App Today{" "}
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </button> */}
                    <div className="align-items-center d-flex gap-5 justify-content-start">
                      <div>
                        <h3 className="target FS40FW600 mb-0">75k+</h3>
                        <p className="downloads-text">Live Users</p>
                      </div>

                      <div
                        style={{
                          width: "1px",
                          height: "50px",
                          background: "rgba(0, 0, 0, 0.2)",
                          margin: "0 20px",
                        }}
                      ></div>

                      <div>
                        <h3 className="target FS40FW600 mb-0">29K+</h3>
                        <p className="downloads-text">Questions</p>
                      </div>

                      <div
                        style={{
                          width: "1px",
                          height: "50px",
                          background: "rgba(0, 0, 0, 0.2)",
                          margin: "0 20px",
                        }}
                      ></div>

                      <div>
                        <h3 className="target FS40FW600 mb-0">22</h3>
                        <p className="downloads-text">Question Types</p>
                      </div>

                    </div>
                  </div>

                  {/* Right Cards */}
                  <div className="col-lg-6">
                    <div className="row g-4">
                      {/* iOS Card */}
                      <div className="col-md-6">
                        <div className="download-card FS40FW600" style={{'--background-color':'#F2F2FF','--text-color':'#0D1830'}}>
                          <p>
                            For <span>iOS</span>
                          </p>
                          {/* <p className="subtitle FS16FW500" style={{'--text-color':'#383838'}}>iOS 26.3</p> */}

                          {/* <button className="primary-btn" onClick={() => window.open(import.meta.env.VITE_PTE_IOS_APP_URL)}>
                            Download Now{" "}
                            <img
                              src="/images/web-new-images/right-arrow.svg"
                              alt="Register Now"
                            />
                          </button> */}
                          <ButtonComp
                          className="mt-2"
                          link={() => window.open(import.meta.env.VITE_PTE_IOS_APP_URL)}
                          btnText={"Download Now"}
                          img="/images/web-new-images/new-dark-arrow.svg"
                        />

                          <div className="card-footer d-flex justify-content-between align-items-center mt-4">
                            {import.meta.env.VITE_PTE_IOS_APP_URL ? 
                              <QRCode value={`${import.meta.env.VITE_PTE_IOS_APP_URL}`} className="qr"/> :
                              <img src="/images/web-new-images/emojis/Updated/sample-qr.svg" alt="QR" className="qr" />
                            }

                            <div className="circle-wrapper" style={{'--background-color':'#fff'}}>
                              <div className="circle-inner" style={{'--background-color':'#F6F6F6'}}>
                                <img
                                  src="/images/web-new-images/emojis/Updated/apple-logo-icon.png"
                                  alt="IOS"
                                  className="device-icon"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Android Card */}
                      <div className="col-md-6">
                        <div className="download-card FS40FW600" style={{'--background-color':'#F2F2FF','--text-color':'#0D1830'}}>
                          <p>
                            For <span>Android</span>
                          </p>
                          {/* <p className="subtitle FS16FW500" style={{'--text-color':'#383838'}}>Android 16</p> */}

                          {/* <button className="primary-btn" onClick={() => window.open(import.meta.env.VITE_PTE_ANDROID_APP_URL)}>
                            Download Now{" "}
                            <img
                              src="/images/web-new-images/right-arrow.svg"
                              alt="Register Now"
                            />
                          </button> */}
                          <ButtonComp
                            className="mt-2"
                            link={() => window.open(import.meta.env.VITE_PTE_ANDROID_APP_URL)}
                            btnText={"Download Now"}
                            img="/images/web-new-images/new-dark-arrow.svg"
                          />


                          <div className="card-footer d-flex justify-content-between align-items-center mt-4">
                            {import.meta.env.VITE_PTE_ANDROID_APP_URL ? 
                            <QRCode value={`${import.meta.env.VITE_PTE_ANDROID_APP_URL}`} className="qr"/> :
                            <img src="/images/web-new-images/emojis/Updated/sample-qr.svg" alt="QR" className="qr" />
                            }

                            <div className="circle-wrapper" style={{'--background-color':'#fff'}}>
                              <div className="circle-inner" style={{'--background-color':'#F6F6F6'}}>
                                <img
                                  src="/images/web-new-images/emojis/Updated/android-icon.png"
                                  alt="Android"
                                  className="device-icon"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="card-wrapper">
            <ReusableHomePageSlider images={images} />
          </div>
        </div>
        {/* Old code */}

        <div className="custom-container success-section pb-5">
          <div className="align-items-center justify-content-between row">
            {/* LEFT CONTENT */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h1 className="hero-title FS40FW600 mb-4">
                How Language Academy <span className="text-success">Apps</span>
                <br />
                <span className="text-success">Increase</span> Chances For
                Success
              </h1>

              <div className="quote-box FS18FW400 mt-2">
                Missing classes due to work commitments? Stuck in traffic during
                your commute? Have a few spare minutes between meetings?
              </div>

              <p className="mt-4 FS17FW500">
                Your PTE preparation never has to stop.
              </p>

              <p className="FS17FW500">
                Our mobile apps deliver the same expert-level training that has
                helped 50,000+ students achieve their goals, now optimized for
                your smartphone and available 24/7.
              </p>

              {/* <button className="primary-btn mt-3" onClick={() => window.open(import.meta.env.VITE_PTE_IOS_APP_URL)}>
                Start Your Mobile Mastery{" "}
                <img
                  src="/images/web-new-images/right-arrow.svg"
                  alt="Register Now"
                />
              </button> */}
              <ButtonComp
                className="mt-5"
                link={() => window.open(import.meta.env.VITE_PTE_IOS_APP_URL)}
                btnText={"Start Your Mobile Mastery"}
                img="/images/web-new-images/new-dark-arrow.svg"
              />
            </div>

            {/* RIGHT IMAGE SECTION */}
            <div className="col-lg-6">
              <img
                src="/images/web-new-images/emojis/Updated/PTE-success.png"
                alt="mobile1"
              />
            </div>
          </div>
        </div>

        <div className="pc-why-choose np-need-crack">
          <div className="custom-container">
            <section className="academy-section py-5">
              <div className="custom-container">
                <div className="hero-title FS40FW600 text-center mb-5">
                  Everything You Need{" "}
                  <span className="text-success">
                    To Crack PTE Core <br></br> & Academic
                  </span>{" "}
                  In Your Pocket
                </div>

                {academySections.map((section, index) => {
                  const imageLeft = index % 2 === 0;
                  return (
                    <div className="row align-items-center mb-5 gap-5" key={index}>
                      <div
                        className={`col-lg-${imageLeft ? 6 : 5} col-md-12 mb-4 mb-lg-0 ${
                          imageLeft ? "" : "order-lg-2"
                        }`}
                      >
                        <div className="academy-app-preview text-center">
                          <img
                            src={section.imageSrc}
                            className="img-fluid"
                            alt="app preview"
                          />
                        </div>
                      </div>
                      <div
                        className={`col-lg-${imageLeft ? 5 : 6} col-md-12 ${
                          imageLeft ? "" : "order-lg-1"
                        }`}
                      >
                        <div
                          className="academy-sound-icon"
                          style={{ background: section.iconBg }}
                        >
                          {section.icon}
                        </div>

                        <h3 className="academy-subtitle">{section.title}</h3>

                        <div className="academy-highlight-box FS16FW500 mt-3 mb-4 fw-700">
                          {section.highlight}
                        </div>

                        <ul className="feature-list">
                          {section.features.map((feature, i) => (
                            <li key={i} className="FS18FW400">
                              {feature}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="text-center">
                {/* <button className="primary-btn" onClick={() => window.open(import.meta.env.VITE_PTE_IOS_APP_URL)}>
                  Experience The Full Power Of Mobile Learning
                </button> */}
              <ButtonComp
                className="mt-80"
                link={() => window.open(import.meta.env.VITE_PTE_IOS_APP_URL)}
                btnText={"Experience The Full Power Of Mobile Learning"}
                img="/images/web-new-images/new-dark-arrow.svg"
              />                
              </div>
            </section>
          </div>
        </div>
        <SkillAreas
          skillAreaTitle={skillAreaTitle}
          lifestyleCards={lifestyleCards}
          leftSection={false}
          className={
            "text-center d-flex flex-column align-items-center justify-content-center"
          }
          skillBottomtitle={"Your schedule doesn't have to limit your success."}
          btnText2={"Get Instant Access"}
        />

        <div className="master-aspect-section ap-minute-count mt-5">
          <div className="custom-container">
            <div className="row">
              {/* <h2 className="hero-title FS40FW600 text-center">
                The{" "}
                <span className="text-success FS40FW600">
                  5-Point Difference & Global Opportunities:
                </span>
                <br />
                Why Every Minute Counts
              </h2> */}
              <h2 className="hero-title FS40FW600 text-center">
                <span className="text-success FS40FW600">Every Minutes{" "}</span>Counts
              </h2>
              <div className="master-cards">
                <div className="master-card">
                  <h2 className="card-title">
                    <span className="top-section FS24FW500 fw-700">PTE</span> <br />
                    <span className="FS20FW500">Global Recognition</span>
                  </h2>
                  <ul className="feature-list">
                    <li className="FS18FW400">
                      <p>
                        Accepted by universities and immigration authorities worldwide
                      </p>
                    </li>
                    <li className="FS18FW400">
                      <p>
                        Fast 24-hour results for urgent applications
                      </p>
                    </li>
                    <li className="FS18FW400">
                      <p>AI-powered scoring ensures consistent, unbiased evaluation</p>
                    </li>
                  </ul>
                </div>
                <div className="master-card card2">
                  <h2 className="card-title">
                    <span className="top-section FS24FW500 fw-700">Preparation Time</span> <br />
                    <span className="FS20FW500"> Maximize Your Potential</span>
                  </h2>
                  <ul className="feature-list">
                    <li className="FS18FW400">
                      <p>
                        Every minute matters when preparing for such important
                        exams
                      </p>
                    </li>
                    <li className="FS18FW400">
                      <p>
                        Consistent daily practice beats intensive cramming
                        sessions
                      </p>
                    </li>
                    <li className="FS18FW400">
                      <p>Mobile accessibility means no wasted opportunities</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="text-center">
                <p className="sub-heading m-0">
                  Don't let a busy schedule cost you your future opportunities.
                </p>
                {/* <Link to="/auth/register" className="primary-btn">
                  Secure Your Success Today
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </Link> */}
              <ButtonComp
                className="mt-80"
                link={"/auth/register"}
                btnText={"Secure Your Success Today"}
                img="/images/web-new-images/new-dark-arrow.svg"
              />                 
              </div>
            </div>
          </div>
        </div>

        <AiPower btnText="Start Free PTE Practice"/>

        <div className="all-language-section language-support mt-5">
          <div className="align-items-center custom-container d-flex flex-column justify-content-center">
            <div className="row">
              <h2 className="hero-title FS40FW600 text-center mb-md-0">
                Comprehensive{" "}
                <span className="text-success FS40FW600">Language Support</span>
              </h2>
            </div>
            <div className="all-language-content col-9">
              <div className="all-lang-cards text-center plus-sans">
                <h2 className="FS20FW500 fw-600">PTE Preparation For Global Success</h2>
                  <p className="FS18FW400">
                    Complete preparation materials for PTE Academic and PTE Core, accepted by institutions and immigration<br/> authorities worldwide.
                    <br />
                    <br />
                    Complete vocabulary translations, cultural context, and comprehensive PTE preparation for<br/>international opportunities.
                  </p>
              </div>
            </div>
            <div className="text-center">
              {/* <Link to="/auth/register" className="primary-btn dark-border">
                Find Your Preparation Path
                <img
                  src="/images/web-new-images/right-arrow.svg"
                  alt="Register Now"
                />
              </Link> */}
              <ButtonComp
                className="mt-5"
                link={"/auth/register"}
                btnText={"Find Your Preparation Path"}
                img="/images/web-new-images/new-dark-arrow.svg"
              />                 
            </div>
          </div>   
        </div>

        <div className="sss-section">
          <TestimonialSection
            title={`<span class="hero-title FS40FW600 text-center mb-md-0">What Our App <br/> <span class="green-text">Users Says</span></span>`}
            btnText="Join 50,000+ of Successful App Users"
            btnLink={import.meta.env.VITE_PTE_IOS_APP_URL}
            sliderList={sliderList}
            titleClass="text-start"
            showBtn={true}
            extraClass={"flex-column flex-lg-row flex-lg-row text-start"}
            extraWidth={"700px"}
          />
        </div>

        <FeatureSection {...featureData} />
        <div className="bottom-line-section">
          <div className="custom-container">
            <SplitSection {...spliteSectionData} />
          </div>
        </div>

        <section className="naati-hero-section bottom-section-radius custom-container">
          <div className="px-3 px-md-4 px-lg-5 hero-container py-5">
            <div className="row align-items-center g-5">
              {/* Left side - Text + Stats */}
              <div className="col-lg-6 text-center text-lg-start">
                <p className="top-section-text FS40FW600 mb-4">
                  Ready To Secure{" "}
                  <span className="text-success FS40FW600">Your Success</span>
                </p>

                <p className="lead-text FS20FW500 mb-4">
                  Don't let a busy lifestyle delay your Australian permanent
                  residency dreams or global opportunities.
                </p>
                <p className="lead-text FS20FW500 mb-4">
                  Download the Language Academy apps today and Join 50K+ of successful students' who've earned their goals through smart, flexible preparation.
                </p>

                <div className="download-buttons mb-5 d-flex flex-wrap justify-content-center justify-content-lg-start gap-3">
                  <a className="downlaod-btn" target="_blank" rel="noopener noreferrer" href={import.meta.env.VITE_PTE_ANDROID_APP_URL}>
                    <img
                      src="/images/web-new-images/google-play-01.svg"
                      alt="Register Now"
                    />
                  </a>
                  <a className="downlaod-btn" target="_blank" rel="noopener noreferrer" href={import.meta.env.VITE_PTE_IOS_APP_URL}>
                    <img
                      src="/images/web-new-images/app-store-01.svg"
                      alt="Register Now"
                    />
                  </a>
                </div>

                <div className="join-community d-flex align-items-center justify-content-center justify-content-lg-start gap-3">
                  <div className="avatars d-flex">
                    <img src="/images/web-new-images/new-content-slider/User-01.svg" alt="user" className="avatar rounded-circle" />
                    <img src="/images/web-new-images/new-content-slider/Pritam.svg" alt="user" className="avatar rounded-circle ms-n3" />
                    <img src="/images/web-new-images/new-content-slider/Karthik-B.svg" alt="user" className="avatar rounded-circle ms-n3" />
                    <img src="/images/web-new-images/new-content-slider/RamimRahman-demo.svg" alt="user" className="avatar rounded-circle ms-n3" />
                    <img src="/images/web-new-images/new-content-slider/SapnaPandey-demo.svg" alt="user" className="avatar rounded-circle ms-n3" />
                  </div>
                  <span className="join-text FS20FW500 fw-600">
                    Join 50K+ Students'
                  </span>
                </div>
              </div>

              {/* Right side - Phones mockup */}
              <div className="col-lg-6">
                <div className="phones-container position-relative text-center">
                  <img
                    src="/images/web-new-images/emojis/Updated/Contact-pte-app.png"
                    alt="NAATI CCL App - Mock Test"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default PTEAppNew;